import React from 'react';
import { Inbox } from 'lucide-react';

type Props = {
  title: string;
  subtitle?: string;
  icon?: React.ComponentType<any>;
};

const EmptyState: React.FC<Props> = ({ title, subtitle, icon: Icon = Inbox }) => {
  return (
    <div
      className="w-full min-h-[220px] py-12 flex flex-col items-center justify-center text-center gap-3"
      role="status"
      aria-live="polite"
    >
      <div className="h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center">
        <Icon className="h-7 w-7 text-slate-400" />
      </div>
      <h3 className="text-xl font-semibold text-slate-900">{title}</h3>
      {subtitle ? (
        <p className="text-sm text-slate-500 max-w-md">{subtitle}</p>
      ) : null}
    </div>
  );
};

export default EmptyState;
